export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20deep%20red%20velvet%20curtains%2C%20warm%20golden%20stage%20lighting%2C%20elegant%20art%20deco%20cinema%20architecture%2C%20rich%20dark%20atmosphere%2C%20dramatic%20spotlight%20beams%2C%20luxurious%20entertainment%20venue%20interior%2C%20no%20people%2C%20theatrical%20mood%2C%20high%20contrast%2C%20ornate%20ceiling%20details%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20film%20projector%20light%20rays%20cutting%20through%20darkness&width=1600&height=900&seq=hero-bg-cinema&orientation=landscape"
          alt="窝窝影院 - 沉浸式观影体验"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-br from-black/75 via-black/55 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 text-accent-300 text-xs md:text-sm font-medium tracking-wide mb-5">
              每日更新 · 完全免费
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4">
              窝窝影院
              <span className="block text-accent-400 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mt-1">
                免费高清影视在线观看平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-white/75 font-light leading-relaxed max-w-xl mx-auto lg:mx-0 mb-3">
              海量最新电影、热播电视剧、热门综艺、动漫番剧一网打尽
            </p>
            <p className="text-sm md:text-base text-white/55 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              窝窝影院汇聚全网优质免费影视资源，覆盖院线大片、国产剧、日韩剧、欧美剧、综艺动漫等全品类内容。
              每日实时更新最新剧集与影片，高清画质流畅播放无缓冲，全程无广告打扰，让您轻松追剧无忧。
              无论是最新上映的院线电影，还是经典口碑佳作，窝窝影院都是您的最佳免费观影选择。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">20000+</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">影视资源覆盖</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">最新剧集同步</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">高清流畅</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">无广告免缓冲</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg text-base whitespace-nowrap transition-colors cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg text-base whitespace-nowrap transition-colors border border-white/20 cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                浏览片库
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[420px] lg:max-w-[480px]">
            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-r from-primary-500/20 via-accent-500/15 to-primary-500/20 rounded-2xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-white/10">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20film%20poster%20composition%20with%20glowing%20warm%20golden%20light%20rays%20emerging%20from%20a%20vintage%20film%20projector%2C%20floating%20film%20reels%2C%20elegant%20movie%20ticket%20stubs%2C%20dark%20theatrical%20background%20with%20subtle%20stars%2C%20rich%20crimson%20and%20gold%20color%20palette%2C%20luxurious%20cinema%20aesthetic%2C%20artistic%20minimalist%20design%2C%20soft%20dramatic%20lighting%2C%203D%20render%20style&width=800&height=1000&seq=hero-poster-main&orientation=portrait"
                  alt="窝窝影院 - 海量影视免费观看"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}